import {
    createEmailCampaign,
    deleteEmailCampaign,
    fetchEmailCampaignById,
    fetchEmailCampaigns,
    updateEmailCampaign,
} from '@/redux/modules/emailCampaigns/emailCampaigns.actions';
import { createSlice } from '@reduxjs/toolkit';
import {
    defaultEmailCampaignsSlice,
    EmailCampaignRequestError,
} from '@/redux/modules/emailCampaigns/emailCampaigns.types';

const emailCampaignsSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchEmailCampaigns.pending, (slice) => {
            slice.isLoading = true;
            slice.fetchError = '';
        });
        builder.addCase(fetchEmailCampaigns.fulfilled, (slice, { payload }) => {
            payload.campaigns.forEach((campaign) => {
                slice.byId[campaign.id] = campaign;
            });
            slice.campaignIds = payload.campaigns.map(({ id }) => id);
            slice.total = payload.total;
            slice.isLoading = false;
        });
        builder.addCase(fetchEmailCampaigns.rejected, (slice, { payload }) => {
            slice.isLoading = false;
            slice.fetchError = payload?.message ?? EmailCampaignRequestError.Other;
        });

        builder.addCase(fetchEmailCampaignById.pending, (slice) => {
            slice.isLoading = true;
            slice.fetchError = '';
        });
        builder.addCase(fetchEmailCampaignById.fulfilled, (slice, { payload }) => {
            slice.byId[payload.id] = payload;
            slice.isLoading = false;
        });
        builder.addCase(fetchEmailCampaignById.rejected, (slice, { payload }) => {
            slice.isLoading = false;
            slice.fetchError = payload?.message ?? EmailCampaignRequestError.Other;
        });

        builder.addCase(createEmailCampaign.pending, (slice) => {
            slice.isSaving = true;
            slice.saveError = '';
            slice.wasSaveSuccessful = undefined;
        });
        builder.addCase(createEmailCampaign.fulfilled, (slice, { payload }) => {
            slice.byId[payload.id] = payload;
            slice.isSaving = false;
            slice.wasSaveSuccessful = true;
        });
        builder.addCase(createEmailCampaign.rejected, (slice, { payload }) => {
            slice.isSaving = false;
            slice.saveError = payload?.message ?? EmailCampaignRequestError.Other;
            slice.wasSaveSuccessful = false;
        });

        builder.addCase(updateEmailCampaign.pending, (slice) => {
            slice.isSaving = true;
            slice.saveError = '';
            slice.wasSaveSuccessful = undefined;
        });
        builder.addCase(updateEmailCampaign.fulfilled, (slice, { payload }) => {
            slice.byId[payload.id] = payload;
            slice.isSaving = false;
            slice.wasSaveSuccessful = true;
        });
        builder.addCase(updateEmailCampaign.rejected, (slice, { payload }) => {
            slice.isSaving = false;
            slice.saveError = payload?.message ?? EmailCampaignRequestError.Other;
            slice.wasSaveSuccessful = false;
        });

        builder.addCase(deleteEmailCampaign.pending, (slice) => {
            slice.isDeleting = true;
            slice.deleteError = '';
        });
        builder.addCase(deleteEmailCampaign.fulfilled, (slice, { meta }) => {
            delete slice.byId[meta.arg];
            slice.campaignIds = slice.campaignIds.filter((id) => id !== meta.arg);
            slice.total = Math.max(slice.total - 1, 0);
            slice.isDeleting = false;
        });
        builder.addCase(deleteEmailCampaign.rejected, (slice, { payload }) => {
            slice.isDeleting = false;
            slice.deleteError = payload?.message ?? EmailCampaignRequestError.Other;
        });
    },
    initialState: defaultEmailCampaignsSlice,
    name: 'emailCampaigns',
    reducers: {},
});

export const { reducer: emailCampaignsReducer } = emailCampaignsSlice;
